// 查看会员信息 （客户交易记录）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>客户交易记录</h3>
            </div>
            <div class="card-button">
              <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui">返回基本信息</el-button>
            </div>
          </div>
          <div class="NumberTable">
            <Table @TouchTheBottom="TouchTheBottom" :PagesData="paging" :tableData="list.tbody" :configTable="list.thead" :config="list"></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetCustSalePage } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "单据号",
            prop: "saleNo",
            operation: "jump",
          },
          {
            label: "单据类型",
            prop: "saleText",
          },
          {
            label: "销售日期",
            prop: "saleDate",
          },
          {
            label: "折前总价",
            prop: "beforeDiscountAmount",
          },
          {
            label: "折后总价",
            prop: "sheetAmount",
          },
          {
            label: "实际交易金额",
            prop: "realAmount",
          },
          {
            label: "门店",
            prop: "shopName",
          },
          {
            label: "不计入升级",
            prop: "vIPInvalidSaleText",
          },
          {
            label: "品牌顾问",
            prop: "saleEmpName",
          },
        ],
        tbody: [], // 表格内容
      },
    };
  },
  created() {
    // 列表数据
    this.RGetCustSalePage();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {
    ReturnSaleTypeText(saleType) {
      let saleText = "";
      switch (saleType) {
        case 0:
          saleText = "销售";
          break;
        case 1:
          saleText = "换货";
          break;
        case 2:
          saleText = "退货";
          break;
        case 3:
          saleText = "预购单提货";
          break;
        case 10:
          saleText = "预购";
          break;
        case 11:
          saleText = "预购撤单";
          break;
      }
      return saleText;
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetCustSalePage();
    },
    RGetCustSalePage() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetCustSalePage(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.vIPInvalidSaleText= item.vIPInvalidSale ? '是':'否'
            item.CopyIndex = (this.paging.page - 1) * this.paging.size + index + 1;
            item.saleText = this.ReturnSaleTypeText(parseInt(item.saleType));
            item.saleDate = this.renderTime(item.saleDate).substring(0, 10);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
